export default __webpack_public_path__ + "static/media/Aura-Egg__76.02656466.png";